import { createSlice } from "@reduxjs/toolkit";
import VwKurumbonustanimtestveriDTO from "src/models/KurumBonusTanim/VwKurumbonustanimtestveriDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IKurumBonusTanimlariTestVeVeriyeGore {
    iptalGosterme: string;
    activeRow: VwKurumbonustanimtestveriDTO;
    open: boolean;
};

export const kurumBonusTanimlariTestVeVeriyeGoreSlice = createSlice<IKurumBonusTanimlariTestVeVeriyeGore, MapReducerPayloads<IKurumBonusTanimlariTestVeVeriyeGore, {
    setIptalGosterme: string;
    setActiveRow: VwKurumbonustanimtestveriDTO;
    setOpen: boolean;
}>>({
    name: "kurumBonusTanimlariTestVeVeriyeGore",
    initialState: {
        iptalGosterme: "E",
        activeRow: new VwKurumbonustanimtestveriDTO(),
        open: false
    },
    reducers: {
        setIptalGosterme: (state, action) => {
            state.iptalGosterme = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
    },
});